export class ApplicationConstants {
   static baseAppUrl = 'https://www.instamaps.cat';
    //static baseAppUrl = 'http://geocat1.geostart.local';
    static defaultLanguageCode = 'ca';
    static visorPasswordUrl = ApplicationConstants.baseAppUrl + '/geocat/aplications/map/loadPrivateMapByBusinessId.action?';
}



// WEBPACK FOOTER //
// ./src/shared/applicationConstants.js